//
import { objectToQueryString } from "../../../helpers/objectToQueryString";
import { API } from "../../api";
async function getProduct(query) {
    // console.log("getProduct -> query", query);
    const CLIENT_ID = process.env.LETS_TRADE_CLIENT_ID ?? "";
    const url = process.env.LETS_TRADE_PRODUCT_URL ?? "";
    return await new API().apiGet({
        baseUrl: url,
        endpoint: `v2/product${objectToQueryString({ ...query, client_id: CLIENT_ID })}`,
        // content: request,
    });
}
export { 
// IGetProductRequest,
getProduct, };
